module.exports = __webpack_public_path__ + "static/media/playInterview.011b1347.svg";